var path = 'dashboard/edit-widget.tpl.html';
var html = " <fieldset ng-disabled=$root.loading> <tb-widget-config widget-type=widget.type type-parameters=typeParameters action-sources=actionSources ng-model=widgetConfig is-data-enabled=isDataEnabled widget-settings-schema=settingsSchema datakey-settings-schema=dataKeySettingsSchema alias-controller=aliasController functions-only=widgetEditMode fetch-entity-keys=\"fetchEntityKeys(entityAliasId, query, type)\" fetch-dashboard-states=fetchDashboardStates(query) on-create-entity-alias=\"createEntityAlias(event, alias, allowedEntityTypes)\" the-form=theForm></tb-widget-config> </fieldset> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/dashboard/edit-widget.tpl.html
// module id = 1423
// module chunks = 1